import { render, staticRenderFns } from "./OperatingRisk.vue?vue&type=template&id=cc690396&scoped=true"
import script from "./OperatingRisk.vue?vue&type=script&lang=js"
export * from "./OperatingRisk.vue?vue&type=script&lang=js"
import style0 from "./OperatingRisk.vue?vue&type=style&index=0&id=cc690396&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc690396",
  null
  
)

export default component.exports